import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery, gql } from '@apollo/client'
import { useNavigate } from 'router'
import { Box } from '@mui/material'
import CardPreview from 'packages/ui/CardPreview'
import { CardDetailsProps, GetWireLineByIdData } from '../utils/types'
import Header from './components/Header'
import Body from './components/Body'
import GraphSection from './components/GraphSection'

export const OPERATION_GET_WIRE_LINE_BY_ID = gql`
  query GetWireLineById($id: ID!) {
    wireLine: getWireLineById(id: $id) {
      id
      name
      hotspot_id
      hotspot {
        id
        name
        state
      }
      wifirstsite {
        id
        name
        city
        state
      }
      connection_type
      wire_type
      use_case
      owner_is_wifirst
      fai {
        id
        name
      }
      ip_address
      effective_ip_address
      download
      upload
      saturation
      total_loss_down
      nb_days_loss
      wan_access_through_ipsec
      created_at
      updated_at
    }
  }
`

const CardDetails: React.FC<CardDetailsProps> = ({ id }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { loading, error, data } = useQuery<GetWireLineByIdData>(OPERATION_GET_WIRE_LINE_BY_ID, {
    variables: { id }
  })

  const wireLine = data?.wireLine

  return (
    <CardPreview
      title={t('wan.card.title')}
      loading={loading}
      error={error ? t('shared.error') : null}
      onClose={() => navigate({ pathname: '..' })}
    >
      {wireLine && (
       <Box sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
        <Header wireLine={wireLine} />
          <Box 
            sx={{ 
              flex: 1,
              overflowY: 'auto',
              scrollbarWidth: 'none',
            }}
          >
            <Box sx={{ py: 4 }}>
              <Body wireLine={wireLine} />
            </Box>
            <Box sx={{ pb: 5 }}>
              <GraphSection lineId={id} />
            </Box>
          </Box>
        </Box>
      )}
    </CardPreview>
  )
}

export default CardDetails
